import { Component, Input, OnInit } from '@angular/core';
import { ModalRef } from '@shared/ui';

@Component({
  template: `
    <!-- TODO: Port modal to webapp stack  -->
  `,
})
export class HiremeModalComponent implements OnInit {
  @Input() freelancerId: number;

  constructor(private modalRef: ModalRef<HiremeModalComponent>) {}

  ngOnInit() {
    // FIXME: port this modal to the webapp stack
    // TODO: get the employer from Auth & Freelancer object from Datastore?
    (<any>window).messagingWebappCompatModals.HireMeModal.initForm({
      // abTestPrehire: true,
      // employer,
      // freelancer,
      // deferred: this.$q.defer(),
      // autoSendPMB,
    });
  }

  close() {
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/projects/hireme-modal/hireme-modal.component.ts